module.exports = __webpack_public_path__ + "img/accountAuthority.4e18bc22.svg";